import { render, staticRenderFns } from "./SharingsPage.vue?vue&type=template&id=c4ad6392"
import script from "./SharingsPage.vue?vue&type=script&lang=js"
export * from "./SharingsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports